import React from 'react';
import { LobsterImportUnitValueSlider } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';

const SLUG = 'bait-import-unit-value';
const SLUG_DB = 'bait-import-unit-value-db';

const DEFAULT_IMPORT_UNIT_VALUE = 0.18;

interface BaitImportUnitValueData {
  updatingParams?: boolean;
  lobsterDisabled?: boolean;
}

export default function BaitImportUnitValue(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const data = getRegistryData<BaitImportUnitValueData>(props);

  const formValue = formContext?.values?.[SLUG] as number | undefined;
  const formDbValue = formContext?.values?.[SLUG_DB] as number | undefined;
  const importUnitValue = formValue ?? DEFAULT_IMPORT_UNIT_VALUE;
  const dbImportUnitValue = formDbValue ?? importUnitValue;
  const updatingParams = data.updatingParams ?? data.lobsterDisabled ?? false;

  const handleImportUnitValueChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = parseFloat(e.target.value);
      formContext?.setValue(SLUG, value);
    },
    [formContext]
  );

  return (
    <LobsterImportUnitValueSlider
      importUnitValue={importUnitValue}
      dbImportUnitValue={dbImportUnitValue}
      handleImportUnitValueChange={handleImportUnitValueChange}
      updatingParams={updatingParams}
    />
  );
}
